<template>
  <div class="d-flex" :class="this.$store.state.menuToggle" id="wrapper">
    <TheSidemenu />
    <!-- Page Content -->
    <div id="page-content-wrapper">
      <TheTopmenu />
      <div class="container-fluid">
        <div>
          <ShowTeams />
        </div>
      </div>
    </div>
    <!-- /#page-content-wrapper -->
  </div>
  <!-- /#wrapper -->
</template>
<script>
import TheSidemenu from "@/components/TheSidemenu";
import TheTopmenu from "@/components/TheTopmenu";
import ShowTeams from "./components/ShowTeams";
export default {
  name: "Teams",
  components: {
    TheSidemenu,
    TheTopmenu,
    ShowTeams,
  },
};
</script>